import React, {Suspense, useEffect} from "react";
import {Route, Switch, Redirect} from "react-router-dom";

//pages
import HomePage from "../pages/home";
import ContactPage from "../pages/static-pages/contact";
import TermsPage from "../pages/static-pages/terms";
import InterestPage from "../pages/interest";
import TestimonialsPage from "../pages/static-pages/testimonials/index";
import SamplePage from "../pages/sample";
import SearchPage from "../pages/search/index";
import ClosedPage from "../pages/static-pages/closed/index";
//account
import SignupPage from "../pages/account/signup";
import LoginPage from "../pages/account/login";
import ForgotPasswordPage from "../pages/account/forgot-password";
import ResetPasswordPage from "../pages/account/reset-password/index";
import ChangePasswordPage from "../pages/account/change-password";

import DashboardPage from "../pages/dashboard/index";
//crates
import CratesPage from "../pages/crates/static/index";
import OneCratePage from "../pages/crates/single-crate/index";
import OneCrateSampledPage from "../pages/crates/single-sampled/index";
//forms
import ClearSamplePage from "../pages/clear-sample/index";
import AfterRegisterPage from "../pages/account/after-register";
import EmailVerifyPage from "../pages/account/emails-verify";
import AlbomPage from "../pages/albom/index";
import ShopPage from "../pages/shop/index";
import ShopItemPage from "../pages/shop-item/index";
import AddCratePage from "../pages/forms/add-crate/index";
import AddCrateToExistPage from "../pages/forms/add-crate-sample/index";
import AddSamplePage from "../pages/forms/add-sample/index";
import AddSyncPage from "../pages/forms/add-sync/index";
import AddMechPage from "../pages/forms/add-mech/index";
import SampleReviewFormPage from "../pages/forms/review/index";
import AffiliatePage from "../pages/account/affilate";
import {ROUTESLIST} from "@/static/urls";
import CongratulationPage from "../pages/congratulations";
import TesterPage from "../pages/tester";
import Notfound from "../pages/notfound";
import PrivateRoute from "./PrivateRoute/PrivateRoute";
import BillingHistoryPage from "../pages/billing-history";
import DemoPayment from "../pages/checkout1/index";
import Dashboard from "../pages/dashboard/dashboard-page/Dashboard";
import DashboardSyncPage from "../pages/dashboard/sync/index";
import DashboardOneSyncPage from "../pages/dashboard/one-sync";
import Header from "../components/header";
import {useLocation} from "react-router-dom";
import PublicRoute from "./PublicRoutes/PublicRoutes";
import {useAuth0} from "@auth0/auth0-react";
import DashboardSecurityPage from "../pages/dashboard/security";
import DigitalLicenseFormPage from "../pages/forms/digital_license/index";
import Player from "../pages/player";
import Footer from "../components/footer";
import ServicesPage from "@/pages/services";
import PackagePage from "@/pages/package";
import MembershipCheckout from "@/pages/membership-checkout";
import MembershipCheckoutSuccess from "@/pages/membership-checkout/success";
import MembershipCheckoutInPlace from "@/pages/membership-checkout/InPlace";

const MainRouter = () => {
    const location = useLocation();
    const {
        logout,
        user,
        isAuthenticated,
        isLoading,
        getAccessTokenSilently,
    } = useAuth0();
    const domain = process.env.REACT_APP_AUTH0_DOMAIN;

    // managing google login and logout
    useEffect(() => {
        const fetchToken = async () => {
            try {
                // Removed Auth0.on("authenticated") block as useAuth0 handles authentication state.
                const currentAccessToken = localStorage.getItem("access_token");
                // console.log("Current Access Token:", currentAccessToken);
                if (!currentAccessToken) {
                    if (!isLoading && isAuthenticated && user) {
                        const token = await getAccessTokenSilently({
                            audience: `https://${domain}/api/v2/`,
                            scope: "openid profile email",
                        });

                        // console.log("Access Token:", token);

                        localStorage.setItem("access_token", token);
                        localStorage.setItem("token", token);
                        localStorage.setItem("useData", JSON.stringify(user));
                        localStorage.setItem("userInfo", JSON.stringify(user));
                        localStorage.setItem("isIdentityLogin", "true");
                        localStorage.setItem("isAuthenticated", "true");
                        localStorage.setItem("isLoading", "false");
                        window.location.reload();
                    }
                }
            } catch (err) {
                console.error("Failed to get access token", err);
            }
        };

        fetchToken();
    }, [isLoading, isAuthenticated, user, getAccessTokenSilently, domain]);
    if (isLoading) {
        return location.pathname === "/"; // Or show a spinner
    }

    return (
        <>
            {/* {location.pathname !== "/userdashboard" ? <Header /> : ""} */}
            {/* Managed condition for old header & new header */}
            {!(
                location.pathname === "/" ||
                location.pathname === "/signup" ||
                location.pathname === "/login" ||
                location.pathname === ROUTESLIST.ACCOUNT_CHANGE_PASSWORD ||
                location.pathname === "/interest" ||
                location.pathname.includes("userdashboard") ||
                location.pathname === "/services" ||
                location.pathname === "/package" ||
                location.pathname === "/player" ||
                location.pathname === '/memberships' ||
                location.pathname.startsWith("/memberships/checkout") ||
                location.pathname.startsWith("/subscription") ||
                location.pathname.startsWith("/memberships")
                ) && <Header auth0Logout={logout}/>}

            {/* <Header /> */}

            {/* Added Private and Public routes */}
            <Suspense fallback={"Loading"}>
                <Switch>
                    <Route
                        exact
                        path={ROUTESLIST.HOME}
                        render={(props) =>
                            localStorage.getItem("token") ? (
                                <Redirect to={ROUTESLIST.CLEAR_SAMPLE}/>
                            ) : (
                                <HomePage {...props}/>
                            )
                        }
                    />
                    {/*<Route path={ROUTESLIST.SERVICES} component={ServicesPage}/>*/}
                    <Route exact path={ROUTESLIST.PACKAGES} component={PackagePage}/>
                    <Route exact path={ROUTESLIST.CHECKOUT_MEMBERSHIP} component={MembershipCheckout}/>
                    <Route exact path={ROUTESLIST.CHECKOUT_MEMBERSHIP_IN_PLACE} component={MembershipCheckoutInPlace}/>
                    <Route exact path={ROUTESLIST.CHECKOUT_MEMBERSHIP_SUCCESS} component={MembershipCheckoutSuccess}/>
                    <Route path={ROUTESLIST.STATIC_CONTACT} component={ContactPage}/>
                    <Route exact path={ROUTESLIST.INTEREST} component={InterestPage}/>
                    <Route
                        path={ROUTESLIST.STATIC_TESTIMONIALS}
                        component={TestimonialsPage}
                    />
                    <Route path={ROUTESLIST.STATIC_TERMS} component={TermsPage}/>
                    <Route path={ROUTESLIST.SAMPLE} component={SamplePage}/>
                    <Route path={ROUTESLIST.SEARCH} component={SearchPage}/>
                    {/* <Route path={ROUTESLIST.SIGNUP} component={SignupPage} /> */}
                    {/* <Route path={ROUTESLIST.LOGIN} component={LoginPage} /> */}
                    <PublicRoute path={ROUTESLIST.SIGNUP} component={SignupPage}/>
                    <PublicRoute path={ROUTESLIST.LOGIN} component={LoginPage}/>
                    <Route path={ROUTESLIST.DASHBOARD} component={DashboardPage}/>
                    {/* New dashboard page */}
                    {/* <Route path={"/userdashboard/"} component={Dashboard} /> */}
                    <PrivateRoute path={"/userdashboard/"} component={Dashboard}/>

                    <Route
                        path={ROUTESLIST.CLOSED_PAGE + ":slug"}
                        component={ClosedPage}
                    />
                    <PrivateRoute path={ROUTESLIST.DASHBOARD_SECURITY}>
                        <DashboardSecurityPage/>
                    </PrivateRoute>
                    <Route path={ROUTESLIST.CRATES} component={CratesPage}/>
                    <Route
                        path={ROUTESLIST.CRATES_CRATE + ":id"}
                        component={OneCratePage}
                    />
                    <Route
                        path={ROUTESLIST.CRATES_SAMPLED + ":id"}
                        component={OneCrateSampledPage}
                    />

                    <Route
                        path={ROUTESLIST.UPLOAD_ADD_CRATE_SAMPLE + ":id"}
                        component={AddCrateToExistPage}
                    />
                    <Route path={ROUTESLIST.UPLOAD_ADD_CRATE} component={AddCratePage}/>
                    <Route path={ROUTESLIST.UPLOAD_SAMPLE} component={AddSamplePage}/>
                    <Route path={ROUTESLIST.UPLOAD_SYNC} component={AddSyncPage}/>
                    <Route path={ROUTESLIST.UPLOAD_MECH} component={AddMechPage}/>
                    <Route path={ROUTESLIST.UPLOAD_REVIEW} component={SampleReviewFormPage}/>
                    <Route path={ROUTESLIST.UPLOAD_DIGITAL_LICENSE} component={DigitalLicenseFormPage}/>

                    <Route path={ROUTESLIST.ALBOM} component={AlbomPage}/>
                    <Route path={ROUTESLIST.SUBSCRIPTION} component={ShopPage}/>
                    {/* <Route path={ROUTESLIST.SUBSCRIPTIONS} component={ShopItemPage} /> */}
                    <PrivateRoute
                        path={ROUTESLIST.SERVICES}
                        component={ShopItemPage}
                    />
                    <PrivateRoute
                        path={ROUTESLIST.CART}
                        component={ShopPage}
                    />
                    <Route path={ROUTESLIST.CONGRATS} component={CongratulationPage}/>
                    <Route
                        path={ROUTESLIST.BILLING_HISTORY}
                        component={BillingHistoryPage}
                    />
                    <PrivateRoute
                        path={ROUTESLIST.BILLING_HISTORY}
                        component={BillingHistoryPage}
                    />
                    <Route
                        path={ROUTESLIST.CHECKOUT}
                        component={DemoPayment}
                    />
                    {/* <Route path={ROUTESLIST.CLEAR_SAMPLE} component={ClearSamplePage} /> */}
                    <PrivateRoute
                        path={ROUTESLIST.CLEAR_SAMPLE}
                        component={ClearSamplePage}
                    />
                    <Route path={ROUTESLIST.DASHBOARD_ONE_SYNC + ':id'} component={DashboardOneSyncPage}/>
                    <Route
                        path={ROUTESLIST.DASHBOARD_SYNC}
                        component={DashboardSyncPage}
                    />

                    <Route
                        path={ROUTESLIST.AFTER_REGISTER}
                        component={AfterRegisterPage}
                    />
                    <Route path={ROUTESLIST.EMAIL_VERIFY} component={EmailVerifyPage}/>
                    <Route
                        path={ROUTESLIST.ACCOUNT_FORGOT_PASSWORD}
                        component={ForgotPasswordPage}
                    />
                    <Route
                        path={ROUTESLIST.ACCOUNT_RESET_PASSWORD + ":token"}
                        component={ResetPasswordPage}
                    />
                    <PrivateRoute
                        path={ROUTESLIST.ACCOUNT_CHANGE_PASSWORD}
                        component={ChangePasswordPage}
                    />
                    <Route path="/account/affiliate" component={AffiliatePage}/>

                    <Route path="/tester" component={TesterPage}/>
                    <Route path="/player" component={Player}/>

                    <Route path="*" component={Notfound}/>
                </Switch>
            </Suspense>
            {
                location.pathname !== "/player" &&
                location.pathname !== ROUTESLIST.ACCOUNT_CHANGE_PASSWORD && (
                    <Footer/>
                )
            }
        </>
    );
};

export default MainRouter;
